import * as React from 'react';
import * as style from './style.css';
import { UIText2 } from '@cian/ui-kit';
import { clsx } from 'clsx';

interface IMedalsCardProps {
  gold: number;
  silver: number;
  bronze: number;
}

export const MedalsCard = ({ gold, silver, bronze }: IMedalsCardProps) => {
  return (
    <div className={style['card']}>
      <div className={style['medals']}>
        <div className={clsx(style['medal'], style['gold'])}>
          <div className={style['medal-label']}>{gold}</div>
        </div>
        <div className={clsx(style['medal'], style['silver'])}>
          <div className={style['medal-label']}>{silver}</div>
        </div>
        <div className={clsx(style['medal'], style['bronze'])}>
          <div className={style['medal-label']}>{bronze}</div>
        </div>
      </div>
      <UIText2>
        Побед в конкурсе <br />
        топ ЖК
      </UIText2>
    </div>
  );
};
